import MoneyWithCurrency from 'modules/core/lib/money'

import { budgetTypesEnum } from './constants'

export const originSection = () => {
  const path = location.pathname

  if (path.includes('attendance')) {
    return 'Time tracking section'
  } else if (path.includes('contributors')) {
    return 'People section'
  } else {
    return 'My projects section'
  }
}

export const isValidBudgetType = (budgetType: string): budgetType is budgetTypesEnum => {
  return [
    'fixed_time_budget',
    'fixed_cost_planning',
    'project_fixed_cost',
    'total_budget',
    'without_budget',
  ].includes(budgetType)
}

export const costRateCell = (
  rate: { chargingCostCents: number; currency: string } | undefined,
  defaultCost: { chargingCostCents: number; currency: string } | undefined,
  locale: string
):
  | { type: 'text'; value: string }
  | { type: 'status'; value: { status: 'info'; label: string } } => {
  const cost = rate?.chargingCostCents ?? defaultCost?.chargingCostCents
  const currency = rate?.currency ?? defaultCost?.currency

  if (!cost || !currency)
    return {
      type: 'status',
      value: {
        status: 'info',
        label: '1',
      },
    }
  return {
    type: 'text',
    value: MoneyWithCurrency({
      amount: cost,
      currency,
      optionalDecimals: true,
      locale,
    }),
  }
}

//TODO: move quotesVisibility and invoicesVisibility to backend creating the proper policies in policies/pages folder

export const quotesVisibility = (
  hasProjectsCostsFeature: boolean,
  canRequestUpsell: boolean,
  isOwnerOrAdmin: boolean,
  hasSalesQuotesManagementFeature: boolean,
  hasQuickQuoteBuilderFF: boolean
) => {
  const canSeeSalesQuotesPageContent =
    hasProjectsCostsFeature &&
    hasSalesQuotesManagementFeature &&
    isOwnerOrAdmin &&
    hasQuickQuoteBuilderFF
  const canSeeSalesQuotesUpsell =
    !canSeeSalesQuotesPageContent && canRequestUpsell && hasQuickQuoteBuilderFF
  return {
    canSeeSalesQuotesPageContent,
    canSeeSalesQuotesUpsell,
  }
}

export const invoicesVisibility = (
  hasProjectsCostsFeature: boolean,
  canRequestUpsell: boolean,
  isOwnerOrAdmin: boolean,
  isSpanishCompany: boolean,
  hasSalesInvoicesManagementFeature: boolean
) => {
  const canSeeSalesInvoicesPageContent =
    hasProjectsCostsFeature && hasSalesInvoicesManagementFeature && isOwnerOrAdmin
  const canSeeSalesInvoicesUpsell =
    !canSeeSalesInvoicesPageContent && canRequestUpsell && isSpanishCompany // Harcoding this country cause we know we dont sell invoices in other countries so upsell wouldnt make sense
  return {
    canSeeSalesInvoicesPageContent,
    canSeeSalesInvoicesUpsell,
  }
}
